/// <reference path="../Common/Helpers/LanguageList.ts" />
/// <reference path="../Common/UserPreference/UserPreferenceStorage.ts" />

namespace Matrix.ScriptInitialization {

    Q.Config.responsiveDialogs = true;
    Q.Config.rootNamespaces.push('Matrix');
    Serenity.EntityDialog.defaultLanguageList = LanguageList.getValue;
    Serenity.HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
    Serenity.DataGrid.defaultRowHeight = 30;
    Serenity.DataGrid.defaultHeaderHeight = 30;
    Serenity.DataGrid.defaultPersistanceStorage = window.localStorage;
    //Serenity.DataGrid.defaultPersistanceStorage = new Common.UserPreferenceStorage(); //TODO: Consider db for storage (UserPreferences)
    if ($.fn['colorbox']) {
        $.fn['colorbox'].settings.maxWidth = "85%";
        $.fn['colorbox'].settings.maxHeight = "85%";
        $.fn['colorbox'].settings.title = function () {
            return this.title === false ? '' : Q.htmlEncode(this.title);
        }
    }
}

var treeGridMixin = Serenity.TreeGridMixin;
window['Serenity']['TreeGridMixin'] = function (options: Serenity.TreeGridMixinOptions<any>) {
    treeGridMixin.call(this, options);
    if (options.toggleField) {
        var dg = options.grid;
        var allCol = Q.tryFirst(dg['allColumns'] || [], function (x) { return x.field == options.toggleField; });
        var col = Q.tryFirst(dg.slickGrid.getColumns(), function (x) { return x.field == options.toggleField; });
        if (col && allCol) {
            col.format = allCol.format;
            col.formatter = col.formatter = allCol.formatter;
        }
    }
} as any;

window['Serenity']['TreeGridMixin'].applyTreeOrdering = treeGridMixin.applyTreeOrdering;

(function () {
    Serenity.ImageUploadEditor.prototype['set_readOnly'] = function (value) {
        if (this.get_readOnly() !== value) {
            if (value) {
                this.uploadInput.attr('disabled', 'disabled');
                try {
                    this.uploadInput.fileupload('disable');
                }
                catch {
                }
            }
            else {
                this.uploadInput.removeAttr('disabled');
                try {
                    this.uploadInput.fileupload('enable');
                } catch {
                }
            }
            this.updateInterface();
        }
    };

    var oldSetValue = Serenity.ImageUploadEditor.prototype["set_value"];
    Serenity.ImageUploadEditor.prototype["set_value"] = function (value: any) {
        if (typeof value === "string") {
            value = Q.trimToNull(value);
            if (value != null) {
                var idx = value.indexOf('/');
                if (idx < 0)
                    value = value.indexOf('\\');
                value = <Serenity.UploadedFile>{
                    Filename: value,
                    OriginalName: value.subString(idx + 1)
                }
            }
        }
        else if (Q.isTrimmedEmpty(value.FileName))
            value = null;

        oldSetValue.call(this, value);
    }
})();


Serenity.CheckboxFormatter.prototype.format = function (ctx) {
    return `<input type="checkbox"${!!ctx.value ? " checked" : ""} disabled />`;
};

var orgGetViewOptions = Serenity.DataGrid.prototype["getViewOptions"];
Serenity.DataGrid.prototype["getViewOptions"] = function() {
    var opt = orgGetViewOptions.call(this);
    if (opt.rowsPerPage != 0 && opt.rowsPerPage <= 100)
        opt.rowsPerPage = 20;
    return opt;
}

Serenity.DataGrid.prototype["getPagerOptions"] = function () {
    return {
        view: this.view,
        rowsPerPage: 20,
        rowsPerPageOptions: [20, 100, 500, 1000, 2500]
    };
};

var orgItemLink = Serenity.SlickFormatting.itemLink;
Serenity.SlickFormatting.itemLink = function (itemType, idField, getText, cssClass, encode) {
    var formatter = orgItemLink(itemType, idField, getText, cssClass, encode);
    return function (ctx) {
        if (ctx.row == -1 && ctx.cell == -1) {
            var text = (getText == null ? ctx.value : getText(ctx)) ?? '';
            return encode ? Q.htmlEncode(text) : text;
        }

        return formatter(ctx);
    }
}

var orgCreateSelectColumn = Serenity.GridRowSelectionMixin.createSelectColumn;
Serenity.GridRowSelectionMixin.createSelectColumn = function (getMixin: () => Serenity.GridRowSelectionMixin): Slick.Column {
    var col = orgCreateSelectColumn.call(this, getMixin) as Slick.Column;
    col.minWidth = 32;
    col.maxWidth = 32;
    col.width = 32;
    return col;
}

var summaryType = (Serenity as any).SummaryType = (Serenity as any).SummaryType || {};
summaryType[summaryType["Disabled"] = -1] = "Disabled";
summaryType[summaryType["None"] = 0] = "None";
summaryType[summaryType["Sum"] = 1] = "Sum";
summaryType[summaryType["Avg"] = 2] = "Avg";
summaryType[summaryType["Min"] = 3] = "Min";
summaryType[summaryType["Max"] = 4] = "Max";
Q.registerEnum(summaryType, 'Serenity.SummaryType');